<template>
	<div class="summary-list">
		<CFullEmpty v-if="isEmpty" class="empty-box" />
		<template v-else>
			<div
				v-for="(item, index) in finalData"
				:key="index"
				class="research-item"
				@click="viewResearchDetail(item)"
			>
				<div class="research-info">
					<img class="list-icon" src="@/assets/images/irstore/touguantiaoyan.svg" alt="" />
					<span>纪要</span>
					<span class="research-time">{{ dateFormatYearMonthDate(item.ptime) }}</span>
				</div>
				<div class="research-title">{{ item.title }}</div>
				<div class="research-author">{{ item.stockName }} {{ toCode(item.fullCode) }}</div>
			</div>
		</template>
		<CFooterLoad ref="footerLoadObs" :more="hasMore" @load-more="loadMoreData" />
	</div>
</template>

<script setup>
import { ref, computed, onMounted, nextTick } from 'vue';
import CFooterLoad from '@/view/enterprise/components/c-footer-load.vue';
import CFullEmpty from '@/view/enterprise/components/c-full-empty.vue';
import { dateFormatYearMonthDate } from '@/utils/api';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';

const emit = defineEmits(['refresh']);
const { viewModule } = useModuleNavigation();
const { research } = useModuleData();
const footerLoadObs = ref(null);
const pageStart = ref(0);
const viewResearchDetail = item => viewModule('research', item);
const toCode = code => {
	if (!code) return;
	let letters = code.match(/[A-Za-z]+/g)[0];
	let numbers = code.match(/[0-9]+/g)[0];
	return numbers + '.' + letters.toUpperCase();
};

const finalData = ref([]);
const loadingMore = ref(false);

const hasMore = computed(() => {
	const total = research?.data?.total;
	return total != null && finalData.value.length < total;
});

const isEmpty = computed(() => finalData.value.length === 0);

const loadData = async () => {
	await research.refresh({ pagestart: pageStart.value, pagenum: 20 });
	if (pageStart.value === 0) {
		finalData.value = research?.data?.rows || [];
	} else {
		finalData.value = finalData.value.concat(research?.data?.rows || []);
	}
};

const loadMoreData = async () => {
	if (!hasMore.value || loadingMore.value) return;
	loadingMore.value = true;
	pageStart.value++;
	try {
		await loadData();
		// 通知父级刷新 Better-scroll，否则内容变高后无法继续滚动
		nextTick(() => emit('refresh'));
	} finally {
		loadingMore.value = false;
	}
};

onMounted(async () => {
	await loadData();
	// CFooterLoad 的 IntersectionObserver 需主动调用 install() 才会生效
	nextTick(() => {
		if (footerLoadObs.value && typeof footerLoadObs.value.install === 'function') {
			footerLoadObs.value.install();
		}
	});
});
</script>

<style lang="less" scoped>
@import '@/style/mixin/text-overflow.less';
.summary-list {
	background: #f7f7f7;
	.empty-box {
		padding: 0.2rem 0;
	}
}
.research-item {
	margin-bottom: 0.08rem;
	font-family: 'PingFang SC';
	width: 100%;
	padding: 0.12rem;
	background: #ffffff;
	.research-info {
		display: flex;
		font-style: normal;
		font-weight: 400;
		font-size: 0.12rem;
		line-height: 0.17rem;
		color: #333333;
		.list-icon {
			margin-right: 0.08rem;
			width: 0.16rem;
			height: 0.16rem;
		}
	}
	.research-time {
		margin-left: 0.08rem;
		font-size: 0.11rem;
		line-height: 0.155rem;
		color: #666666;
	}
	.research-title {
		margin-top: 0.1rem;
		max-height: 0.72rem;
		font-style: normal;
		font-weight: 400;
		font-size: 0.16rem;
		line-height: 0.24rem;
		color: #333333;
		.text-overflow-multi-row(3);
	}
	.research-author {
		margin-top: 0.1rem;
		font-style: normal;
		font-weight: 400;
		font-size: 0.11rem;
		line-height: 0.155rem;
	}
}
</style>
